// firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyA554cXiIsmgKiREYQOsxaPVV0l49xrF64",
  authDomain: "my-virtual-pi-5b926.firebaseapp.com",
  projectId: "my-virtual-pi-5b926",
  storageBucket: "my-virtual-pi-5b926.firebasestorage.app",
  messagingSenderId: "405336797732",
  appId: "1:405336797732:web:4217d33448c04b22179eb1",
  measurementId: "G-X5VQBJ6275"
};
 

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);


export { messaging, getToken, onMessage };
